<style scoped>
    .ellips {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
<template>
  <v-layout>
    <v-card
      v-for="deviceTelemetry of telemetry"
      :key="deviceTelemetry.deviceId"
    >
        <div style="text-align: left; margin: 1rem; margin-bottom: 0.5rem">
            <div class="headline">{{ deviceTelemetry.deviceLabel }}</div>
            <p>{{ deviceTelemetry.deviceId }}</p>
            <div class="body-1">
            Last 10 telemetry samples sent by the device.
            </div>
        </div>
      <!-- <v-card-title>
        <p class="headline">{{ deviceTelemetry.deviceLabel }}</p>
        <h5 style="margin-left: 1rem">({{ deviceTelemetry.deviceId }})</h5>
      </v-card-title> -->
      <v-card-text style="margin-top: -1rem">
        <v-card
          v-for="(telIdx, index) in Object.keys(
            groupedSamples[deviceTelemetry.deviceId]
          )"
          :key="index"
        >
          <v-card-title class="ellips">
            <img
              :src="'/assets/telemetry/' + telIdx + '.png'"
              style="width: 2rem; height: 2rem"
              onerror="this.style.display='none'"
            />
            <h3>{{ telIdx.charAt(0).toUpperCase() + telIdx.slice(1) }}</h3>
          </v-card-title>

          <v-card-text style="margin-top: -2rem" class="body-1">
            <p>
              Last value at
              <span class="font-weight-bold">{{
                groupedSamples[deviceTelemetry.deviceId][telIdx][
                  groupedSamples[deviceTelemetry.deviceId][telIdx].length - 1
                ].timestamp
                  .toString()
                  .split("GMT")[0]
              }}</span>
            </p>

            <p style="margin-left: 0.5rem">Value: <span  class="font-weight-bold">{{
              toStringValue(
                groupedSamples[deviceTelemetry.deviceId][telIdx][
                  groupedSamples[deviceTelemetry.deviceId][telIdx].length - 1
                ].value
              )
            }}</span></p>

            <v-sparkline
              v-if="
                groupedSamples[deviceTelemetry.deviceId][telIdx].length > 0 &&
                typeof groupedSamples[deviceTelemetry.deviceId][telIdx][0]
                  .value === 'number'
              "
              :value="
                groupedSamples[deviceTelemetry.deviceId][telIdx].map(
                  (s) => s.value
                )
              "
              :gradient="['purple']"
              :smooth="10 || false"
              :padding="8"
              :line-width="2"
              :stroke-linecap="'round'"
              :gradient-direction="'top'"
              auto-draw
              style="margin-top:-1rem"
            ></v-sparkline>
            <!-- {{groupedSamples[deviceTelemetry.deviceId][index]}} -->
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-layout>
</template>
<script>
export default {
  name: "MapTelemetry",

  props: {
    /**
     * @Array of @DeviceTelemetry
     */
    telemetry: Array,
  },

  computed: {
    groupedSamples() {
      let map = [];
      this.telemetry.forEach((t) => {
        if (!map[t.deviceId]) {
          map[t.deviceId] = [];
        }
        t.samples.forEach((s) => {
          if (!map[t.deviceId][s.id]) map[t.deviceId][s.id] = [];
          map[t.deviceId][s.id].push(s);
        });
      });
      return map;
    },
  },

  methods: {
    toStringValue(value) {
      let res = "";
      if (typeof value === "number" || typeof value === "string") res += value;
      else if (typeof value === "object"){
        let first = true;
        for (let i in value) {
          res = res + ((first) ? " " : ", ") + i + ": " + value[i];
          first = false;
        }
      }
      return res;
    },
  },
};
</script>